import axios from 'axios';
import {requestCanceller} from './axiosCancelToken'

axios.defaults.headers.post['Content-Type'] = 'application/json';

axios.interceptors.request.use((config)=>{
    let token = localStorage.getItem('token');
    config.headers.Authorization =  token ? `Bearer ${token}` : '';
    return config;
})
axios.interceptors.response.use(null, error => {
    const expectedError =
    error.response &&
    error.response.status >= 400 &&
    error.response.status < 500;
    const multerSizeError = error.response.data.includes('File too large')  ? true : false;
    const multerFormatError = error.response.data.includes('Accepted file: zip') ? true : false;
    if (!expectedError && !requestCanceller().isCancel(error) & !multerFormatError && !multerSizeError) {
        alert('خطا در برقراری ارتباط با سرور')
    }

    return Promise.reject(error);
});
const http = {
    get: axios.get,
    post: axios.post,
    patch: axios.patch,
    delete: axios.delete
};
export default http;
